import {requirePermission} from '@/modules/auth/permissions'
import {CustomersTable} from '@/modules/customers/components'
import {CustomersFilters} from '@/modules/customers/components/customer-filters'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {HStack} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {LuPlus} from 'react-icons/lu'
import * as z from 'zod'
import {useGetInfiniteCustomers} from '@/modules/customers/api'

const SearchSchema = z.object({
  filters: z.object({name: z.string().optional()}).optional(),
})

export const Route = createFileRoute('/configuration/customers/')({
  beforeLoad: requirePermission('organisation.manage'),
  component: CustomersPage,
  validateSearch: SearchSchema,
})

const LIMIT = 50

function CustomersPage() {
  const {t} = useTranslate('common')

  const search = Route.useSearch()

  const infiniteCustomers = useGetInfiniteCustomers({
    limit: LIMIT,
    sort: {
      dir: 'desc',
      field: 'createdAt',
    },
    filters: {
      name: search.filters?.name,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteCustomers

  return (
    <>
      <HStack justifyContent="space-between" width="100%">
        <LinkButton to="/configuration/customers/new" marginY="1rem" colorPalette="cyan" size="sm">
          <LuPlus />
          {t('add_new')}
        </LinkButton>

        <CustomersFilters />
      </HStack>

      <CustomersTable virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}} table={{}} />
    </>
  )
}
